import React, { useState } from "react";
import { InputLabelAlert } from "../../../../layout";
import {
  mCPF,
  mTel,
  Aguarde,
} from "../../../../../helpers/general";
import {
  validateCPF,
} from "../../../../../helpers/validation";
import { sendData } from "../../../../../helpers/auth";
import { uriList } from "../../../../../helpers/config";
import { connect } from "react-redux";
import { setProposta, setClienteDados } from "../../../../../store/actions/dados";
import { swalError, swalMessage } from "../../../../swal";
import { Spinner } from "react-bootstrap";

// Estados do fluxo de autorização
const ETAPA = {
  FORMULARIO: 'formulario',
  TOKEN_SMS: 'token_sms',
  AUTORIZADO: 'autorizado',
};

function AutorizacaoCreditoTrabalhador({ ...props }) {
  // Campos do formulário
  const [cpf, setCpf] = useState("");
  const [nome, setNome] = useState("");
  // const [ddd, setDdd] = useState("");
  const [telefone, setTelefone] = useState("");

  // Estados de controle
  const [warning, setWarning] = useState({});
  const [consultando, setConsultando] = useState(false);
  const [cpfValido, setCpfValido] = useState(false);
  const [clienteId, setClienteId] = useState(null);
  const [etapaAtual, setEtapaAtual] = useState(ETAPA.FORMULARIO);

  // Estados do token SMS
  const [codigoSms, setCodigoSms] = useState("");
  const [tokenEnviado, setTokenEnviado] = useState(false);
  const [validandoToken, setValidandoToken] = useState(false);
  const [dadosAutorizacao, setDadosAutorizacao] = useState(null);

  // Estados de resultado
  const [autorizacaoExistente, setAutorizacaoExistente] = useState(null);
  const [mensagemStatus, setMensagemStatus] = useState(null);

  // Carregar dados do cliente quando CPF for válido
  const carregarDadosCliente = async (cpfValue) => {
    setConsultando(true);
    setDadosAutorizacao(null);
    setAutorizacaoExistente(null);
    setMensagemStatus(null);

    try {
      const res = await sendData({
        uri: uriList("pessoa"),
        content: { cpf: cpfValue },
        method: "POST",
      });

      setConsultando(false);

      if (res.status && res.status > 200) {
        // Cliente não encontrado, limpar campos exceto CPF
        setCpfValido(true);
        return;
      }

      // Cliente encontrado, preencher dados
      if (res.data) {
        setClienteId(res.data.id);
        setNome(res.data.nome || "");

        // Extrair DDD e telefone
        const telCompleto = res.data.telefone || res.data.celular || "";
        if (telCompleto) {
          const telLimpo = telCompleto.replace(/\D/g, "");
          if (telLimpo.length >= 10) {
            // setDdd(telLimpo.substring(0, 2));
            setTelefone(mTel(telLimpo));
          }
        }

        setCpfValido(true);
      }
    } catch (e) {
      setConsultando(false);
      console.log("Erro ao carregar dados do cliente:", e);
      setCpfValido(true);
    }
  };

  // Handler para CPF
  const handleCpf = (e) => {
    setCpfValido(false);
    setWarning({ ...warning, cpf: 0 });
    setDadosAutorizacao(null);
    setAutorizacaoExistente(null);
    setMensagemStatus(null);

    let nums = /\d/;
    let cpfValue = e.currentTarget.value;

    if (nums.test(cpfValue)) {
      cpfValue = mCPF(cpfValue);
      setCpf(cpfValue);

      if (cpfValue.length >= 14) {
        const valid = validateCPF(cpfValue);
        if (valid) {
          carregarDadosCliente(cpfValue);
        } else {
          setWarning({ ...warning, cpf: 1 });
        }
      }
      return false;
    } else if (!cpfValue) {
      setCpf("");
    }

    return false;
  };

  // Handler para mudança de campos
  const handleChange = (e) => {
    const { name, value } = e.currentTarget;
    setWarning({ ...warning, [name]: 0 });

    switch (name) {
      case "nome":
        setNome(value.toUpperCase());
        break;
      // case "ddd":
      //   // Apenas números, máximo 2 dígitos
      //   const dddLimpo = value.replace(/\D/g, "").substring(0, 2);
      //   setDdd(dddLimpo);
      //   break;
      case "telefone":
        setTelefone(mTel(value));
        break;
      default:
        break;
    }
  };

  // Validar campos do formulário
  const validarCampos = () => {
    let valid = true;
    let newWarning = {};

    if (!cpf || !validateCPF(cpf)) {
      newWarning.cpf = 1;
      valid = false;
    }

    if (!nome || nome.trim().length < 3) {
      newWarning.nome = 1;
      valid = false;
    }

    // if (!ddd || ddd.length !== 2) {
    //   newWarning.ddd = 1;
    //   valid = false;
    // }

    if (!telefone || telefone.replace(/\D/g, "").length < 11) {
      newWarning.telefone = 1;
      valid = false;
    }

    setWarning(newWarning);
    return valid;
  };

  // Limpar todos os campos
  const limpar = () => {
    setCpf("");
    setNome("");
    // setDdd("");
    setTelefone("");
    setCpfValido(false);
    setClienteId(null);
    setWarning({});
    setDadosAutorizacao(null);
    setAutorizacaoExistente(null);
    setMensagemStatus(null);
    setEtapaAtual(ETAPA.FORMULARIO);
    setCodigoSms("");
    setTokenEnviado(false);

    if (props.reRender) props.reRender();
  };

  // Avançar - Validar autorização no Dataprev
  const avancar = async () => {
    if (!validarCampos()) {
      console.log("creditoTrabalhador.avancar - Campos inválidos");
      return;
    }

    setConsultando(true);
    setMensagemStatus(null);

    const telefoneCompleto = telefone.replace(/\D/g, "");

    try {
      const res = await sendData({
        uri: uriList("validarAutorizacaoDataprev"),
        content: {
          cpf: cpf.replace(/\D/g, ""),
          nome,
          // ddd,
          telefone: telefoneCompleto,
          cliente_id: clienteId,
        },
        method: "POST",
      });

      setConsultando(false);

      if (res.status && res.status > 200) {
        const msgErro = res.erro || res.message || "Erro ao validar autorização.";
        swalError({ title: msgErro });
        return;
      }

      // Verificar se cliente já possui autorização ativa
      if (res.autorizado || res.data?.autorizado) {
        const _autorizacoes = res.data?.data?.autorizacoes || res.data?.autorizacoes || [];
        const _validade = _autorizacoes.length > 0 ? _autorizacoes[0].validade : null;
        const _validadeFormatada = _validade
          ? new Date(_validade).toLocaleDateString("pt-BR") + " " + new Date(_validade).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
          : null;

        setAutorizacaoExistente({ ...res.data, autorizacoes: _autorizacoes, validade: _validadeFormatada });
        setEtapaAtual(ETAPA.AUTORIZADO);
        setMensagemStatus({
          tipo: "success",
          texto: _validadeFormatada
            ? `Cliente já possui autorização vigente até ${_validadeFormatada}.`
            : "Cliente já possui autorização vigente."
        });
        return;
      }

      // Verificar impedimentos
      if (res.data?.impedimentos && res.data.impedimentos.length > 0) {
        const impedimentosTexto = res.data.impedimentos.join(", ");
        swalError({
          title: "Impedimentos encontrados",
          text: impedimentosTexto
        });
        return;
      }

      // Atualizar ID do cliente se foi cadastrado
      if (res.data?.cliente_id) {
        setClienteId(res.data.cliente_id);
      }

      // Guardar dados da autorização
      setDadosAutorizacao(res.data);

      // Solicitar Token SMS
      await solicitarTokenSms(res.data);

    } catch (e) {
      setConsultando(false);
      console.log("Erro ao validar autorização:", e);
      swalError({ title: e.message || "Erro ao validar autorização." });
    }
  };

  // Solicitar Token SMS
  const solicitarTokenSms = async (dadosAuth = dadosAutorizacao) => {
    setConsultando(true);

    const telefoneCompleto = telefone.replace(/\D/g, "");

    try {
      // Chama o endpoint para solicitar o token SMS para o cliente
      const res = await sendData({
        uri: uriList("solicitarTokenSMS"),
        content: {
          cpf: cpf.replace(/\D/g, ""),
          telefone: telefoneCompleto,
          cliente_id: dadosAuth?.cliente_id || clienteId,
          nome: nome,
        },
        method: "POST",
      });

      if (res.status && res.status > 200) {
        setConsultando(false);
        const msgErro = res.erro || res.message || "Erro ao solicitar token SMS.";
        swalError({ title: msgErro });
        return;
      }

      // Verificar se o backend retornou que já existe autorização (não enviou token)
      if (res.autorizado || res.data?.autorizado) {
        setConsultando(false);
        const _autorizacoes = res.data?.data?.autorizacoes || res.data?.autorizacoes || [];
        const _validade = _autorizacoes.length > 0 ? _autorizacoes[0].validade : null;
        const _validadeFormatada = _validade
          ? new Date(_validade).toLocaleDateString("pt-BR") + " " + new Date(_validade).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })
          : null;

        setAutorizacaoExistente({ ...res.data, autorizacoes: _autorizacoes, validade: _validadeFormatada });
        setEtapaAtual(ETAPA.AUTORIZADO);
        setMensagemStatus({
          tipo: "success",
          texto: _validadeFormatada
            ? `Cliente já possui autorização vigente até ${_validadeFormatada}.`
            : "Cliente já possui autorização vigente."
        });
        return;
      }

      setTokenEnviado(true);
      setEtapaAtual(ETAPA.TOKEN_SMS);
      setConsultando(false);

      swalMessage({
        title: "Token SMS enviado!",
        text: "Informe o código recebido no telefone."
      });

    } catch (e) {
      setConsultando(false);
      console.log("Erro ao solicitar token SMS:", e);
      swalError({ title: e.message || "Erro ao solicitar token SMS." });
    }
  };

  // Handler para código SMS
  const handleCodigoSms = (e) => {
    let value = e.currentTarget.value.toUpperCase().trim();
    // Aceita até 15 caracteres
    value = value.substring(0, 15);
    setCodigoSms(value);
    setWarning({ ...warning, codigoSms: 0 });
  };

  // Validar Token SMS
  const validarTokenSms = async () => {
    if (!codigoSms || codigoSms.length < 4) {
      setWarning({ ...warning, codigoSms: 1 });
      return;
    }

    setValidandoToken(true);

    try {
      const res = await sendData({
        uri: uriList("validarTokenSMS"),
        content: {
          cpf: cpf.replace(/\D/g, ""),
          codigo: codigoSms,
          id: dadosAutorizacao?.id || dadosAutorizacao?.autorizacao_id,
          usuario: props.user?.id,
        },
        method: "POST",
      });

      if (res.status && res.status > 200) {
        setValidandoToken(false);
        const msgErro = res.erro || res.message || "Código inválido ou expirado.";
        setWarning({ ...warning, codigoSms: 1 });
        swalError({ title: msgErro });
        return;
      }

      // Token válido, registrar autorização
      await registrarAutorizacao();

    } catch (e) {
      setValidandoToken(false);
      console.log("Erro ao validar token SMS:", e);
      setWarning({ ...warning, codigoSms: 1 });
      swalError({ title: e.message || "Erro ao validar token SMS." });
    }
  };

  // Registrar Autorização no Dataprev
  const registrarAutorizacao = async () => {
    setValidandoToken(true);

    try {
      const res = await sendData({
        uri: uriList("registrarAutorizacaoDataprev"),
        content: {
          cpf: cpf.replace(/\D/g, ""),
          nome,
          // ddd,
          telefone: telefone.replace(/\D/g, ""),
          cliente_id: clienteId,
          id: dadosAutorizacao?.id || dadosAutorizacao?.autorizacao_id,
          codigo: codigoSms,
        },
        method: "POST",
      });

      if (res.status && res.status > 200) {
        setValidandoToken(false);
        const msgErro = res.erro || res.message || "Erro ao registrar autorização.";
        swalError({ title: msgErro });
        return;
      }

      // Consultar status final da autorização
      await consultarStatusFinal();

    } catch (e) {
      setValidandoToken(false);
      console.log("Erro ao registrar autorização:", e);
      swalError({ title: e.message || "Erro ao registrar autorização." });
    }
  };

  // Consultar status final da autorização
  const consultarStatusFinal = async () => {
    try {
      const res = await sendData({
        uri: uriList("validarAutorizacaoDataprev"),
        content: {
          cpf: cpf.replace(/\D/g, ""),
          nome,
          // ddd,
          telefone: telefone.replace(/\D/g, ""),
          cliente_id: clienteId,
          consultaFinal: true,
        },
        method: "POST",
      });

      setValidandoToken(false);

      if (res.status && res.status > 200) {
        // Mesmo com erro, mostrar que foi processado
        setEtapaAtual(ETAPA.AUTORIZADO);
        setMensagemStatus({
          tipo: "info",
          texto: "Autorização processada. Verifique o status no sistema."
        });
        return;
      }

      // Autorização concluída com sucesso
      setAutorizacaoExistente(res.data);
      setEtapaAtual(ETAPA.AUTORIZADO);
      setMensagemStatus({
        tipo: "success",
        texto: res.data?.mensagem || "Autorização registrada com sucesso!"
      });

      swalMessage({
        title: "Sucesso!",
        text: "Autorização registrada com sucesso!"
      });

    } catch (e) {
      setValidandoToken(false);
      console.log("Erro ao consultar status final:", e);
      // Mesmo com erro, mostrar que foi processado
      setEtapaAtual(ETAPA.AUTORIZADO);
      setMensagemStatus({
        tipo: "info",
        texto: "Autorização processada. Verifique o status no sistema."
      });
    }
  };

  // Reenviar Token SMS
  const reenviarTokenSms = async () => {
    setCodigoSms("");
    setWarning({});
    await solicitarTokenSms();
  };

  // Voltar para o formulário
  const voltarFormulario = () => {
    setEtapaAtual(ETAPA.FORMULARIO);
    setCodigoSms("");
    setTokenEnviado(false);
    setWarning({});
  };

  // Nova autorização
  const novaAutorizacao = () => {
    limpar();
  };

  return (
    <>
      <fieldset className="col-12" style={{ height: "100%" }}>
        <h4
          className="display-4 text-center font-weight-bold"
          style={{ marginBottom: "10px", color: "#3E6C84" }}
        >
          Autorização
        </h4>

        <div className="form" style={{ overflow: "hidden" }}>
          {/* Etapa: Formulário */}
          {etapaAtual === ETAPA.FORMULARIO && (
            <>
              <div className="row flex">
                <div className="form-group col-md-4">
                  <InputLabelAlert
                    type="tel"
                    label="CPF"
                    id="cpf"
                    name="cpf"
                    value={cpf}
                    handle={handleCpf}
                    autoComplete="off"
                    length="14"
                    focus={true}
                    required
                    warning={warning.cpf}
                    onContextMenu={(e) => e.preventDefault()}
                  />
                  {/* <InputAlert display={warning.cpf} messages={"CPF inválido."} /> */}
                </div>
                {cpfValido && (
                  <div className="form-group col-md-8">
                    <InputLabelAlert
                      type="text"
                      label="Nome"
                      id="nome"
                      name="nome"
                      value={nome}
                      handle={handleChange}
                      autoComplete="off"
                      required
                      warning={warning.nome}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                    {/* <InputAlert display={warning.nome} messages={"Nome inválido."} /> */}
                  </div>
                )}
              </div>

              {cpfValido && (
                <div className="row flex">
                  {/* <div className="form-group col-md-2">
                    <InputLabelAlert
                      type="tel"
                      label="DDD"
                      id="ddd"
                      name="ddd"
                      value={ddd}
                      handle={handleChange}
                      autoComplete="off"
                      length="2"
                      required
                      warning={warning.ddd}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                    <InputAlert display={warning.ddd} messages={"DDD inválido."} />
                  </div> */}
                  <div className="form-group col-md-4">
                    <InputLabelAlert
                      type="tel"
                      label="Telefone"
                      id="telefone"
                      name="telefone"
                      value={telefone}
                      handle={handleChange}
                      autoComplete="off"
                      // length="12"
                      required
                      warning={warning.telefone}
                      onContextMenu={(e) => e.preventDefault()}
                    />
                    {/* <InputAlert display={warning.telefone} /> */}
                  </div>
                </div>
              )}

              {/* Mensagem de autorização existente */}
              {autorizacaoExistente && mensagemStatus && (
                <div
                  className="row"
                  style={{
                    border: "0.5px solid",
                    borderColor: mensagemStatus.tipo === "warning" ? "orange" : "lightGray",
                    color: mensagemStatus.tipo === "warning" ? "orange" : "#3E6C84",
                    padding: "10px",
                    marginBottom: "15px",
                    borderRadius: "5px",
                    backgroundColor: mensagemStatus.tipo === "warning" ? "#fff3cd" : "#f8f9fa",
                  }}
                >
                  <div className="col-12 text-center">
                    <h6 className="font-weight-bold m-0">{mensagemStatus.texto}</h6>
                  </div>
                </div>
              )}

              {/* Botões do formulário */}
              <div className="row flex mt-3">
                <div className="form-group col-md-6">
                  <button
                    style={{ backgroundColor: "#6c757d", width: "100%" }}
                    onClick={limpar}
                    className="btn btn-md btn-secondary mb-1 font-weight-bold"
                    disabled={!cpf}
                  >
                    Limpar
                  </button>
                </div>
                <div className="form-group col-md-6">
                  <button
                    style={{ backgroundColor: "#3E6C84", width: "100%" }}
                    onClick={avancar}
                    className="btn btn-md btn-info mb-1 font-weight-bold"
                    disabled={
                      !cpfValido ||
                      !nome ||
                      // !ddd ||
                      !telefone ||
                      consultando ||
                      (autorizacaoExistente && mensagemStatus?.tipo === "warning")
                    }
                  >
                    Avançar
                  </button>
                </div>
              </div>
            </>
          )}

          {/* Etapa: Token SMS */}
          {etapaAtual === ETAPA.TOKEN_SMS && (
            <div
              style={{
                maxWidth: "500px",
                margin: "0 auto",
                padding: "20px",
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                backgroundColor: "#f8f9fa"
              }}
            >
              <div className="text-center mb-4">
                <h5 style={{ color: "#3E6C84" }}>
                  Validação por SMS
                </h5>
                <p className="font-weight-bold" style={{ color: "#3E6C84", marginBottom: "5px" }}>
                  CPF: {cpf}
                </p>
                <p className="text-muted">
                  Um código foi enviado para o telefone {telefone}
                </p>
              </div>

              <div className="form-group">
                <InputLabelAlert
                  type="text"
                  label="Código SMS"
                  id="codigoSms"
                  name="codigoSms"
                  value={codigoSms}
                  handle={handleCodigoSms}
                  autoComplete="new-password"
                  length="15"
                  focus={true}
                  required
                  warning={warning.codigoSms}
                  onContextMenu={(e) => e.preventDefault()}
                />
                {/* <InputAlert display={warning.codigoSms} messages={"Código inválido ou expirado."} /> */}
              </div>

              <div className="row mt-4">
                <div className="col-4">
                  <button
                    style={{ backgroundColor: "#6c757d", width: "100%" }}
                    onClick={voltarFormulario}
                    className="btn btn-md btn-secondary font-weight-bold"
                    disabled={validandoToken}
                  >
                    Voltar
                  </button>
                </div>
                <div className="col-4">
                  <button
                    style={{ backgroundColor: "#ffc107", width: "100%", color: "#212529" }}
                    onClick={reenviarTokenSms}
                    className="btn btn-md btn-warning font-weight-bold"
                    disabled={validandoToken || consultando}
                  >
                    Reenviar
                  </button>
                </div>
                <div className="col-4">
                  <button
                    style={{ backgroundColor: "#28a745", width: "100%" }}
                    onClick={validarTokenSms}
                    className="btn btn-md btn-success font-weight-bold"
                    disabled={!codigoSms || validandoToken}
                  >
                    {validandoToken ? (
                      <Spinner animation="border" size="sm" />
                    ) : (
                      "Validar"
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Etapa: Autorizado */}
          {etapaAtual === ETAPA.AUTORIZADO && (
            <div
              style={{
                maxWidth: "500px",
                margin: "0 auto",
                padding: "20px",
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                backgroundColor: mensagemStatus?.tipo === "success" ? "#d4edda" : "#f8f9fa"
              }}
            >
              <div className="text-center mb-4">
                <h5 style={{ color: mensagemStatus?.tipo === "success" ? "#155724" : "#3E6C84" }}>
                  {mensagemStatus?.tipo === "success" ? "Dados da Autorização" : "Processamento Concluído"}
                </h5>
                <p style={{ color: mensagemStatus?.tipo === "success" ? "#155724" : "#6c757d" }}>
                  {mensagemStatus?.texto}
                </p>
              </div>

              {autorizacaoExistente && (
                <div
                  style={{
                    padding: "10px",
                    backgroundColor: "#fff",
                    borderRadius: "5px",
                    marginBottom: "15px"
                  }}
                >
                  <div className="row">
                    <div className="col-6">
                      <small className="text-muted">CPF</small>
                      <p className="font-weight-bold m-0">{cpf}</p>
                    </div>
                    <div className="col-6">
                      <small className="text-muted">Nome</small>
                      <p className="font-weight-bold m-0">{nome}</p>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div className="col-6">
                      <small className="text-muted">Telefone</small>
                      <p className="font-weight-bold m-0">{telefone}</p>
                    </div>
                    {(autorizacaoExistente.validade || autorizacaoExistente.dtAutorizacao) && (
                      <div className="col-6">
                        <small className="text-muted">Validade</small>
                        <p className="font-weight-bold m-0" style={{ color: "#155724" }}>
                          {autorizacaoExistente.validade || autorizacaoExistente.dtAutorizacao}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              <div className="row mt-4">
                <div className="col-12">
                  <button
                    style={{ backgroundColor: "#3E6C84", width: "100%" }}
                    onClick={novaAutorizacao}
                    className="btn btn-md btn-info font-weight-bold"
                  >
                    Nova Autorização
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </fieldset>

      {(consultando || validandoToken) && <Aguarde />}
    </>
  );
}

function mapStateToProps(state) {
  return {
    user: state.dados.user,
    proposta: state.dados.proposta,
    detalhes: state.dados.detalhes,
    clienteDados: state.dados.clienteDados,
  };
}

function mapActionToProps(dispatch) {
  return {
    alterarProposta(novaProposta) {
      dispatch(setProposta(novaProposta));
    },
    setClienteDados(novoCliente) {
      dispatch(setClienteDados(novoCliente));
    },
  };
}

export default connect(mapStateToProps, mapActionToProps)(AutorizacaoCreditoTrabalhador);
